export const state = () => ({
  showLeadProfileModal: false
})

export const mutations = {
  SHOW_LEAD_PROFILE_MODAL(state) {
    state.showLeadProfileModal = true
  },
  HIDE_LEAD_PROFILE_MODAL(state) {
    state.showLeadProfileModal = false
  }
}
